import {Routes} from '@angular/router';
import {MainComponent} from './components/pages/main/main.component';
import {DestinationsPageComponent} from './components/pages/destinations-page/destinations-page.component';
import {DestinationPageComponent} from './components/pages/destinations-page/items/destination-page/destination-page.component';
import {AdventuresPageComponent} from './components/pages/adventures-page/adventures-page.component';
import {CountryPageComponent} from './components/pages/destinations-page/items/destination-page/country-page/country-page.component';
import {CityPageComponent} from './components/pages/destinations-page/items/destination-page/country-page/city-page/city-page.component';
import {RoutePageComponent} from './components/pages/destinations-page/items/destination-page/country-page/route-page/route-page.component';
import {AdventureTypePageComponent} from './components/pages/adventures-page/adventure-type-page/adventure-type-page.component';
import {HotelPageComponent} from './components/pages/hotel-page/hotel-page.component';
import {FeedbackPageComponent} from './components/pages/feedback-page/feedback-page.component';
import {LoginComponent} from './components/pages/login/login.component';
import {AdminComponent} from './components/pages/admin/admin.component';
import {ServicesPageComponent} from './components/pages/services-page/services-page.component';
import {MapPageComponent} from './components/pages/map-page/map-page.component';
import {MenuVerticalSliderComponent} from './components/elements/menu-vertical-slider/menu-vertical-slider.component';
import {VouchersPageComponent} from './components/pages/vouchers-page/vouchers-page.component';
import {AuthGuard} from './services/auth.guard';
import {RoleGuard} from './interceptors/role.guard';
import {UserRole} from './model/role.enum';
import {VoucherPageComponent} from './components/pages/vouchers-page/voucher-page/voucher-page.component';
import {SetRouteComponent} from './components/pages/set-route/set-route.component';
import {MobServicePageComponent} from './components/pages/services-page/elements/mob-service-page/mob-service-page.component';

export const routes: Routes = [{
  path: 'journal',
  loadComponent: () => import('./components/pages/journal/journal-page.component').then(m => m.JournalPageComponent)
},
  {
    path: 'journal/:slug',
    loadComponent: () => import('./components/pages/journal/journal-page.component').then(m => m.JournalPageComponent)
  },
  {
    path: 'admin/articles',
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [(component: {
      canLeave: () => boolean
    }) => component.canLeave()],
    data: {
      roles: [UserRole.ADMIN]
    },
    loadComponent: () => import('./components/pages/journal/article-editor.component').then(m => m
      .ArticleEditorComponent)
  },
  {
    path: '',
    component: MainComponent,
    pathMatch: 'full'
  },
  {
    path: 'destinations',
    component: DestinationsPageComponent
  },
  {
    path: 'destinations/:name',
    component: DestinationPageComponent
  },
  {
    path: 'destinations/:name/:countryName',
    component: CountryPageComponent
  },
  {
    path: 'destinations/:name/:countryName/:cityName',
    component: CityPageComponent
  },
  {
    path: 'destinations/:name/:countryName/route/:routeName',
    component: RoutePageComponent
  },
  {
    path: ':continent/:country/:city/:hotel',
    component: HotelPageComponent
  },
  {
    path: 'adventures',
    component: AdventuresPageComponent
  },
  {
    path: 'adventures/:type',
    component: AdventureTypePageComponent
  },
  {
    path: 'services',
    component: ServicesPageComponent
  },
  {
    path: 'services/:service',
    component: MobServicePageComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'feedback',
    component: FeedbackPageComponent
  },
  {
    path: 'map',
    component: MapPageComponent
  },
  {
    path: 'test',
    component: MenuVerticalSliderComponent
  },
  {
    path: 'set-route',
    canActivate: [AuthGuard, RoleGuard],
    component: SetRouteComponent,
    data: {
      roles: [UserRole.ADMIN]
    }
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, RoleGuard],
    component: AdminComponent,
    data: {
      roles: [UserRole.ADMIN]
    }
  },

  {
    path: 'documents',
    canActivate: [AuthGuard, RoleGuard],
    component: VouchersPageComponent,
    data: {
      roles: [UserRole.ADMIN, UserRole.VOUCHER_MANAGER]
    }
  },

  {
    path: 'documents/:id',
    canActivate: [AuthGuard, RoleGuard],
    component: VoucherPageComponent,
    data: {
      roles: [UserRole.ADMIN, UserRole.VOUCHER_MANAGER]
    }
  },
];
